var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 6.6665C2.36811 6.6665 2.66659 6.36803 2.66659 5.99984C2.66659 5.63165 2.36811 5.33317 1.99992 5.33317C1.63173 5.33317 1.33325 5.63165 1.33325 5.99984C1.33325 6.36803 1.63173 6.6665 1.99992 6.6665Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 1.99984C2.36811 1.99984 2.66659 1.70136 2.66659 1.33317C2.66659 0.964981 2.36811 0.666504 1.99992 0.666504C1.63173 0.666504 1.33325 0.964981 1.33325 1.33317C1.33325 1.70136 1.63173 1.99984 1.99992 1.99984Z",
    fill: "#F9FAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 11.3332C2.36811 11.3332 2.66659 11.0347 2.66659 10.6665C2.66659 10.2983 2.36811 9.99984 1.99992 9.99984C1.63173 9.99984 1.33325 10.2983 1.33325 10.6665C1.33325 11.0347 1.63173 11.3332 1.99992 11.3332Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 6.6665C2.36811 6.6665 2.66659 6.36803 2.66659 5.99984C2.66659 5.63165 2.36811 5.33317 1.99992 5.33317C1.63173 5.33317 1.33325 5.63165 1.33325 5.99984C1.33325 6.36803 1.63173 6.6665 1.99992 6.6665Z",
    stroke: "#F9FAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 1.99984C2.36811 1.99984 2.66659 1.70136 2.66659 1.33317C2.66659 0.964981 2.36811 0.666504 1.99992 0.666504C1.63173 0.666504 1.33325 0.964981 1.33325 1.33317C1.33325 1.70136 1.63173 1.99984 1.99992 1.99984Z",
    stroke: "#F9FAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 11.3332C2.36811 11.3332 2.66659 11.0347 2.66659 10.6665C2.66659 10.2983 2.36811 9.99984 1.99992 9.99984C1.63173 9.99984 1.33325 10.2983 1.33325 10.6665C1.33325 11.0347 1.63173 11.3332 1.99992 11.3332Z",
    stroke: "#F9FAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburgerIcon.425342758e66c9365ec4884211d974f4.svg";
export { ForwardRef as ReactComponent };